import randomSubset from "../randomSubset";
import randomElement from "../randomElement";
import defaultParams from '../defaultParams';
import shuffle from "../shuffle";

function Picture(minigameData, state){
    var n;
    var n_right;
    switch (Number(state.objects.difficulty)) {
        case 0:
		    n = minigameData.variantCount ? minigameData.variantCount[0] : defaultParams.variantCountPicture[0];
            n_right = randomElement([n-3, n-2, n-1]);
            break;
		case 1:
			n = minigameData.variantCount ? minigameData.variantCount[1] : defaultParams.variantCountPicture[1];
            n_right = randomElement([n-4, n-3, n-2]);
            break;
		default:
            throw new Error(`Difficulty '${state.objects.difficulty}' is not implemented`);
    }
    let task = randomElement(minigameData.data.questions);
    let var_true = [];
    let var_false = [];
    for (let i = 0; i < task.correct_ans.length; i++){
        var_true.push({element: task.correct_ans[i], correct: true});
    }
    for (let i = 0; i < task.wrong_ans.length; i++){
        var_false.push({element: task.wrong_ans[i], correct: false});
    }
    var_true = randomSubset(var_true, n_right);
    var_false = randomSubset(var_false, n - n_right);
    let variants = var_true.concat(var_false);
    return {
        title: task.qst,
        set: shuffle(variants),
    };
}

export default Picture;